import { FinanceApplicationsFrequencyReportModel } from '@/shared/models/finance-applications-frequency-report.model';
import { FinanceApplicationsFrequencyReportUiModel } from '@/shared/ui-models/finance-applications-frequency-report.ui-model';

function mapToUi(
  financeApplicationsMonthlyReport: FinanceApplicationsFrequencyReportModel
): FinanceApplicationsFrequencyReportUiModel {
  return {
    ...financeApplicationsMonthlyReport
  };
}

const financeApplicationsMonthlyReportMapper = { mapToUi };

export default financeApplicationsMonthlyReportMapper;
